module.exports = __webpack_public_path__ + "img/4.657cd1cf.jpg";